export default function If({
  test = false,
  children = null,
  otherwise = null
}) {
  return !!test ? children : otherwise;
}
